import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "st" }
const _hoisted_2 = {
  key: 0,
  class: "st-grid",
  "aria-busy": "true",
  "aria-label": "Chargement des paramètres"
}
const _hoisted_3 = { class: "st-main" }
const _hoisted_4 = {
  key: 1,
  class: "st-error",
  role: "alert"
}
const _hoisted_5 = { class: "st-main" }
const _hoisted_6 = {
  class: "st-card",
  "aria-labelledby": "st-identity"
}
const _hoisted_7 = { class: "st-logo" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "st-drop-empty"
}
const _hoisted_10 = { class: "st-logo-text" }
const _hoisted_11 = { class: "st-logo-actions" }
const _hoisted_12 = {
  key: 0,
  class: "st-badge"
}
const _hoisted_13 = { class: "st-fields" }
const _hoisted_14 = { class: "st-field st-field--wide" }
const _hoisted_15 = ["aria-invalid"]
const _hoisted_16 = {
  class: "st-help",
  id: "st-name-help"
}
const _hoisted_17 = {
  key: 0,
  class: "st-err"
}
const _hoisted_18 = { class: "st-count" }
const _hoisted_19 = { class: "st-field st-field--wide" }
const _hoisted_20 = { class: "st-input-icon" }
const _hoisted_21 = ["aria-invalid"]
const _hoisted_22 = { class: "st-help" }
const _hoisted_23 = {
  key: 0,
  class: "st-err"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  class: "st-card",
  "aria-labelledby": "st-colors"
}
const _hoisted_26 = { class: "st-colors" }
const _hoisted_27 = { class: "st-color-head" }
const _hoisted_28 = ["for"]
const _hoisted_29 = { class: "st-color-row" }
const _hoisted_30 = ["title"]
const _hoisted_31 = ["value", "aria-label", "onInput"]
const _hoisted_32 = ["id", "onUpdate:modelValue", "placeholder", "aria-invalid", "aria-describedby", "onBlur"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = ["aria-label", "aria-pressed", "title", "onClick"]
const _hoisted_36 = {
  key: 0,
  class: "ph ph-check",
  "aria-hidden": "true"
}
const _hoisted_37 = ["id"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "st-err"
}
const _hoisted_42 = {
  class: "st-card",
  "aria-labelledby": "st-contact"
}
const _hoisted_43 = { class: "st-fields" }
const _hoisted_44 = { class: "st-field" }
const _hoisted_45 = { class: "st-input-icon" }
const _hoisted_46 = ["aria-invalid"]
const _hoisted_47 = {
  key: 0,
  class: "st-help"
}
const _hoisted_48 = { class: "st-err" }
const _hoisted_49 = { class: "st-field" }
const _hoisted_50 = { class: "st-input-icon" }
const _hoisted_51 = ["aria-invalid"]
const _hoisted_52 = {
  key: 0,
  class: "st-help"
}
const _hoisted_53 = { class: "st-err" }
const _hoisted_54 = { class: "st-field" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "st-field st-field--wide" }
const _hoisted_57 = {
  class: "st-card",
  "aria-labelledby": "st-prefs"
}
const _hoisted_58 = {
  class: "st-chips",
  role: "radiogroup",
  "aria-label": "Devise"
}
const _hoisted_59 = ["aria-checked", "onClick"]
const _hoisted_60 = {
  key: 0,
  class: "st-card",
  "aria-labelledby": "st-packaging-fees"
}
const _hoisted_61 = { class: "st-field" }
const _hoisted_62 = { class: "input-group" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "input-group-text" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_67 = {
  key: 1,
  class: "st-card",
  "aria-labelledby": "st-refund-fees"
}
const _hoisted_68 = { class: "st-field" }
const _hoisted_69 = { class: "input-group" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "input-group-text" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_74 = {
  class: "st-card",
  "aria-labelledby": "st-bank"
}
const _hoisted_75 = { class: "st-fields" }
const _hoisted_76 = { class: "st-field st-field--wide" }
const _hoisted_77 = ["aria-invalid"]
const _hoisted_78 = ["value"]
const _hoisted_79 = {
  class: "st-help",
  id: "st-bank-help"
}
const _hoisted_80 = {
  key: 0,
  class: "st-err"
}
const _hoisted_81 = { key: 1 }
const _hoisted_82 = {
  class: "st-card",
  "aria-labelledby": "st-terms"
}
const _hoisted_83 = { class: "st-help" }
const _hoisted_84 = { class: "st-count" }
const _hoisted_85 = {
  class: "st-aside",
  "aria-label": "Aperçu"
}
const _hoisted_86 = { class: "st-card st-preview" }
const _hoisted_87 = { class: "st-brand" }
const _hoisted_88 = { class: "st-brand-logo" }
const _hoisted_89 = ["src"]
const _hoisted_90 = { key: 1 }
const _hoisted_91 = ["href"]
const _hoisted_92 = { class: "st-preview-list" }
const _hoisted_93 = { class: "st-ticket" }
const _hoisted_94 = {
  key: 0,
  class: "st-savebar",
  role: "status"
}
const _hoisted_95 = { class: "st-savebar-text" }
const _hoisted_96 = { class: "st-savebar-actions" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = ["disabled"]
const _hoisted_99 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[79] || (_cache[79] = _createElementVNode("header", { class: "st-head" }, [
      _createElementVNode("span", { class: "st-eyebrow" }, "Paramètres"),
      _createElementVNode("h1", { class: "st-title" }, "Paramètres généraux"),
      _createElementVNode("p", { class: "st-sub" }, "Identité, coordonnées et conditions de votre société. Ces informations apparaissent sur l'application, les tickets et les factures.")
    ], -1)),
    _createVNode(_component_SettingsNav),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
              return _createElementVNode("section", {
                key: n,
                class: "st-card"
              }, _cache[30] || (_cache[30] = [
                _createElementVNode("span", { class: "st-skel st-skel--title" }, null, -1),
                _createElementVNode("span", { class: "st-skel st-skel--field" }, null, -1),
                _createElementVNode("span", { class: "st-skel st-skel--field" }, null, -1)
              ]))
            }), 64))
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("aside", { class: "st-aside" }, [
            _createElementVNode("section", { class: "st-card" }, [
              _createElementVNode("span", { class: "st-skel st-skel--block" })
            ])
          ], -1))
        ]))
      : (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[32] || (_cache[32] = _createElementVNode("i", {
              class: "ph ph-warning-circle",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[33] || (_cache[33] = _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Impossible de charger les paramètres."),
              _createElementVNode("p", null, "Vérifiez votre connexion puis réessayez.")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
            }, "Réessayer")
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 2,
            class: "st-grid",
            novalidate: "",
            onSubmit: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("section", _hoisted_6, [
                _cache[43] || (_cache[43] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-identification-card",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-identity" }, "Identité de la société"),
                    _createElementVNode("p", null, "Le logo et le nom affichés dans l'application et sur les documents.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["st-drop", { 'is-drag': _ctx.dragging, 'has-logo': !!_ctx.logoPreview }]),
                    role: "button",
                    tabindex: "0",
                    "aria-label": "Importer un logo (cliquer ou déposer une image)",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileInput?.click())),
                    onKeydown: [
                      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.fileInput?.click()), ["prevent"]), ["enter"])),
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.fileInput?.click()), ["prevent"]), ["space"]))
                    ],
                    onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.dragging = true), ["prevent"])),
                    onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.dragging = false), ["prevent"])),
                    onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
                  }, [
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreview,
                          alt: "Logo de la société"
                        }, null, 8, _hoisted_8))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[34] || (_cache[34] = [
                          _createElementVNode("i", {
                            class: "ph ph-image-square",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode(" Aucun logo ", -1)
                        ]))),
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "st-drop-hint" }, [
                      _createElementVNode("i", {
                        class: "ph ph-upload-simple",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" Changer")
                    ], -1))
                  ], 34),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Logo", -1)),
                    _cache[39] || (_cache[39] = _createElementVNode("p", null, "Glissez une image ici ou cliquez pour choisir un fichier. PNG transparent recommandé, 2 Mo maximum.", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fileInput?.click()))
                      }, _cache[36] || (_cache[36] = [
                        _createElementVNode("i", {
                          class: "ph ph-upload-simple",
                          "aria-hidden": "true"
                        }, null, -1),
                        _createTextVNode(" Importer ", -1)
                      ])),
                      (_ctx.logoFile)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-light",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetLogo && _ctx.resetLogo(...args)))
                          }, " Annuler le nouveau logo "))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.logoFile)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[37] || (_cache[37] = [
                          _createElementVNode("i", {
                            class: "ph ph-dot-outline",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode(" Nouveau logo, pas encore enregistré", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("input", {
                    ref: "fileInput",
                    class: "visually-hidden",
                    type: "file",
                    accept: "image/png,image/jpeg,image/webp,image/gif",
                    tabindex: "-1",
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFileChangeLogo && _ctx.onFileChangeLogo(...args)))
                  }, null, 544)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { for: "st-name" }, [
                      _createTextVNode("Nom de la société "),
                      _createElementVNode("span", {
                        class: "st-req",
                        "aria-hidden": "true"
                      }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "st-name",
                      ref: "nameInput",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.name) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                      maxlength: "100",
                      placeholder: "Ex. GrowLogistics",
                      required: "",
                      "aria-invalid": !!_ctx.errors.name,
                      "aria-describedby": "st-name-help",
                      onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateField('name')))
                    }, null, 42, _hoisted_15), [
                      [_vModelText, _ctx.form.name]
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.errors.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.errors.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_18, _toDisplayString((_ctx.form.name || "").length) + "/100", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { for: "st-website" }, "Site web", -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[41] || (_cache[41] = _createElementVNode("i", {
                        class: "ph ph-globe",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "st-website",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.website) = $event)),
                        type: "url",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.website }]),
                        maxlength: "255",
                        placeholder: "https://exemple.com",
                        "aria-invalid": !!_ctx.errors.website,
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => {_ctx.normalizeWebsite(); _ctx.validateField('website')})
                      }, null, 42, _hoisted_21), [
                        [_vModelText, _ctx.form.website]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.errors.website)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.errors.website), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "https:// est ajouté automatiquement si besoin."))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_25, [
                _cache[48] || (_cache[48] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-palette",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-colors" }, "Couleurs de la plateforme"),
                    _createElementVNode("p", null, " Appliquées à l'administration, à l'espace client et à l'application livreur. L'aperçu est immédiat ici ; les autres espaces les prennent au prochain chargement. ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorFields, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: c.key,
                      class: "st-color"
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", {
                          for: `st-${c.key}`
                        }, _toDisplayString(c.label), 9, _hoisted_28),
                        _createElementVNode("span", null, _toDisplayString(c.hint), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", {
                          class: "st-swatch",
                          style: _normalizeStyle({ background: _ctx.effectiveColor(c.key) }),
                          title: `Choisir la ${c.label.toLowerCase()}`
                        }, [
                          _createElementVNode("input", {
                            type: "color",
                            value: _ctx.effectiveColor(c.key),
                            "aria-label": `Choisir la ${c.label.toLowerCase()}`,
                            onInput: ($event: any) => (_ctx.onPickColor(c.key, $event))
                          }, null, 40, _hoisted_31)
                        ], 12, _hoisted_30),
                        _withDirectives(_createElementVNode("input", {
                          id: `st-${c.key}`,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form[c.key]) = $event),
                          type: "text",
                          class: _normalizeClass(["form-control st-hex", { 'is-invalid': _ctx.errors[c.key] }]),
                          maxlength: "7",
                          spellcheck: "false",
                          autocomplete: "off",
                          placeholder: `${c.default} (défaut)`,
                          "aria-invalid": !!_ctx.errors[c.key],
                          "aria-describedby": `st-${c.key}-help`,
                          onBlur: ($event: any) => {_ctx.normalizeColor(c.key); _ctx.validateField(c.key)}
                        }, null, 42, _hoisted_32), [
                          [
                            _vModelText,
                            _ctx.form[c.key],
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.form[c.key])
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-light",
                              onClick: ($event: any) => (_ctx.setColor(c.key, ''))
                            }, _cache[44] || (_cache[44] = [
                              _createElementVNode("i", {
                                class: "ph ph-arrow-counter-clockwise",
                                "aria-hidden": "true"
                              }, null, -1),
                              _createTextVNode(" Par défaut ", -1)
                            ]), 8, _hoisted_33))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "st-presets",
                        role: "group",
                        "aria-label": `Couleurs suggérées — ${c.label.toLowerCase()}`
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.presets, (p) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: p,
                            type: "button",
                            class: _normalizeClass(["st-preset", { 'is-active': _ctx.effectiveColor(c.key) === p }]),
                            style: _normalizeStyle({ background: p }),
                            "aria-label": p,
                            "aria-pressed": _ctx.effectiveColor(c.key) === p,
                            title: p,
                            onClick: ($event: any) => (_ctx.setColor(c.key, p === c.default ? '' : p))
                          }, [
                            (_ctx.effectiveColor(c.key) === p)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                              : _createCommentVNode("", true)
                          ], 14, _hoisted_35))
                        }), 128))
                      ], 8, _hoisted_34),
                      _createElementVNode("div", {
                        id: `st-${c.key}-help`,
                        class: _normalizeClass(["st-contrast", _ctx.colorCheck(c.key).ok ? 'is-ok' : 'is-bad']),
                        "aria-live": "polite"
                      }, [
                        (_ctx.colorCheck(c.key).valid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", {
                                class: "st-contrast-sample",
                                style: _normalizeStyle({ background: _ctx.effectiveColor(c.key) })
                              }, "Aa", 4),
                              (_ctx.colorCheck(c.key).ok)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                    _cache[45] || (_cache[45] = _createTextVNode(" Texte blanc lisible ", -1)),
                                    _createElementVNode("b", null, _toDisplayString(_ctx.colorCheck(c.key).ratio) + ":1", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                    _cache[46] || (_cache[46] = _createTextVNode(" Trop clair : texte blanc peu lisible ", -1)),
                                    _createElementVNode("b", null, _toDisplayString(_ctx.colorCheck(c.key).ratio) + ":1", 1),
                                    _createTextVNode(" (min. " + _toDisplayString(c.min) + ":1) ", 1)
                                  ])),
                              (!_ctx.colorCheck(c.key).ok)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "st-contrast-fix",
                                    onClick: ($event: any) => (_ctx.fixColor(c.key))
                                  }, _cache[47] || (_cache[47] = [
                                    _createElementVNode("i", {
                                      class: "ph ph-magic-wand",
                                      "aria-hidden": "true"
                                    }, null, -1),
                                    _createTextVNode(" Ajuster automatiquement ", -1)
                                  ]), 8, _hoisted_40))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.errors[c.key] || "Format attendu : #RRGGBB (ex. #2563EB)."), 1))
                      ], 10, _hoisted_37)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_42, [
                _cache[56] || (_cache[56] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-address-book",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-contact" }, "Coordonnées"),
                    _createElementVNode("p", null, "Pour que vos clients et partenaires puissent vous joindre.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _cache[50] || (_cache[50] = _createElementVNode("label", { for: "st-email" }, "Email", -1)),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[49] || (_cache[49] = _createElementVNode("i", {
                        class: "ph ph-envelope-simple",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "st-email",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.email) = $event)),
                        type: "email",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.email }]),
                        maxlength: "150",
                        placeholder: "contact@exemple.com",
                        autocomplete: "email",
                        "aria-invalid": !!_ctx.errors.email,
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateField('email')))
                      }, null, 42, _hoisted_46), [
                        [_vModelText, _ctx.form.email]
                      ])
                    ]),
                    (_ctx.errors.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.errors.email), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[52] || (_cache[52] = _createElementVNode("label", { for: "st-phone" }, "Téléphone", -1)),
                    _createElementVNode("div", _hoisted_50, [
                      _cache[51] || (_cache[51] = _createElementVNode("i", {
                        class: "ph ph-phone",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "st-phone",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.phone) = $event)),
                        type: "tel",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.phone }]),
                        maxlength: "20",
                        placeholder: "+212 600 000000",
                        autocomplete: "tel",
                        "aria-invalid": !!_ctx.errors.phone,
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateField('phone')))
                      }, null, 42, _hoisted_51), [
                        [_vModelText, _ctx.form.phone]
                      ])
                    ]),
                    (_ctx.errors.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.errors.phone), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", { for: "st-city" }, "Ville du siège", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "st-city",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.siege) = $event)),
                      class: "form-select"
                    }, [
                      _cache[53] || (_cache[53] = _createElementVNode("option", { value: "" }, "— Choisir une ville —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option,
                          value: option
                        }, _toDisplayString(option), 9, _hoisted_55))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.siege]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _cache[55] || (_cache[55] = _createElementVNode("label", { for: "st-address" }, "Adresse", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      id: "st-address",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.adresse) = $event)),
                      class: "form-control",
                      rows: "2",
                      maxlength: "500",
                      placeholder: "N°, rue, quartier…"
                    }, null, 512), [
                      [_vModelText, _ctx.form.adresse]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_57, [
                _cache[57] || (_cache[57] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-currency-circle-dollar",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-prefs" }, "Devise"),
                    _createElementVNode("p", null, "Affichée avec les montants (CRBT, frais, factures, tickets).")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_58, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyOptions, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c,
                      type: "button",
                      role: "radio",
                      class: _normalizeClass(["st-chip", { 'is-active': _ctx.form.devis === c }]),
                      "aria-checked": _ctx.form.devis === c,
                      onClick: ($event: any) => (_ctx.form.devis = c)
                    }, _toDisplayString(c), 11, _hoisted_59))
                  }), 128))
                ])
              ]),
              (_ctx.canPackagingFees)
                ? (_openBlock(), _createElementBlock("section", _hoisted_60, [
                    _cache[59] || (_cache[59] = _createElementVNode("header", { class: "st-card-head" }, [
                      _createElementVNode("span", { class: "st-card-icon" }, [
                        _createElementVNode("i", {
                          class: "ph ph-package",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", { id: "st-packaging-fees" }, "Frais d'emballage (bon livraison stock)"),
                        _createElementVNode("p", null, "Frais par colis proposés sur les bons de livraison stock. Un client avec des frais d'emballage personnalisés (fiche client) garde les siens.")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_61, [
                      _cache[58] || (_cache[58] = _createElementVNode("label", { for: "st-packaging-fees-input" }, "Frais généraux / colis", -1)),
                      _createElementVNode("div", _hoisted_62, [
                        _withDirectives(_createElementVNode("input", {
                          id: "st-packaging-fees-input",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.packagingFees) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01",
                          class: "form-control",
                          disabled: _ctx.packagingFeesLoading,
                          onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.savePackagingFees && _ctx.savePackagingFees(...args)), ["prevent"]), ["enter"]))
                        }, null, 40, _hoisted_63), [
                          [_vModelText, _ctx.packagingFees]
                        ]),
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.form.devis || "DH"), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          disabled: _ctx.savingPackagingFees || _ctx.packagingFeesLoading,
                          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.savePackagingFees && _ctx.savePackagingFees(...args)))
                        }, [
                          (_ctx.savingPackagingFees)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Enregistrer")
                              ], 64))
                        ], 8, _hoisted_65)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canRefundFees)
                ? (_openBlock(), _createElementBlock("section", _hoisted_67, [
                    _cache[61] || (_cache[61] = _createElementVNode("header", { class: "st-card-head" }, [
                      _createElementVNode("span", { class: "st-card-icon" }, [
                        _createElementVNode("i", {
                          class: "ph ph-hand-coins",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", { id: "st-refund-fees" }, "Frais de service des remboursements"),
                        _createElementVNode("p", null, "Frais généraux appliqués aux nouvelles demandes de remboursement. Un client avec des frais personnalisés (fiche client) garde les siens.")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_68, [
                      _cache[60] || (_cache[60] = _createElementVNode("label", { for: "st-refund-fees-input" }, "Frais généraux", -1)),
                      _createElementVNode("div", _hoisted_69, [
                        _withDirectives(_createElementVNode("input", {
                          id: "st-refund-fees-input",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.refundFees) = $event)),
                          type: "number",
                          min: "0",
                          step: "0.01",
                          class: "form-control",
                          disabled: _ctx.refundFeesLoading,
                          onKeydown: _cache[24] || (_cache[24] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.saveRefundFees && _ctx.saveRefundFees(...args)), ["prevent"]), ["enter"]))
                        }, null, 40, _hoisted_70), [
                          [_vModelText, _ctx.refundFees]
                        ]),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.form.devis || "DH"), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          disabled: _ctx.savingRefundFees || _ctx.refundFeesLoading,
                          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.saveRefundFees && _ctx.saveRefundFees(...args)))
                        }, [
                          (_ctx.savingRefundFees)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_73))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Enregistrer")
                              ], 64))
                        ], 8, _hoisted_72)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_74, [
                _cache[64] || (_cache[64] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-bank",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-bank" }, "Banque de la société"),
                    _createElementVNode("p", null, "Utilisée pour les virements aux clients lors de la facturation.")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _cache[63] || (_cache[63] = _createElementVNode("label", { for: "st-bank-select" }, "Banque", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "st-bank-select",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.bank_id) = $event)),
                      class: _normalizeClass(["form-select", { 'is-invalid': _ctx.errors.bank_id }]),
                      "aria-invalid": !!_ctx.errors.bank_id,
                      "aria-describedby": "st-bank-help"
                    }, [
                      _cache[62] || (_cache[62] = _createElementVNode("option", { value: "" }, "— Aucune (pas de frais de virement) —", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (b) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: b.id,
                          value: String(b.id)
                        }, _toDisplayString(b.name) + _toDisplayString(b.code ? ` (code ${b.code})` : ""), 9, _hoisted_78))
                      }), 128))
                    ], 10, _hoisted_77), [
                      [_vModelSelect, _ctx.form.bank_id]
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      (_ctx.errors.bank_id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_ctx.errors.bank_id), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_81, " La banque du client est détectée à partir des 3 premiers chiffres de son RIB. Client de la même banque : aucun frais. Client d'une autre banque : " + _toDisplayString(_ctx.bankFees) + " " + _toDisplayString(_ctx.form.devis || "DH") + " de frais de virement déduits de la facture. ", 1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_82, [
                _cache[66] || (_cache[66] = _createElementVNode("header", { class: "st-card-head" }, [
                  _createElementVNode("span", { class: "st-card-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-scroll",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "st-terms" }, "Conditions générales"),
                    _createElementVNode("p", null, "Le texte accepté par vos clients.")
                  ])
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "st-conditions",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.conditions) = $event)),
                  class: "form-control st-terms",
                  rows: "12",
                  maxlength: "20000",
                  "aria-label": "Conditions générales",
                  placeholder: "Rédigez vos conditions générales…"
                }, null, 512), [
                  [_vModelText, _ctx.form.conditions]
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _cache[65] || (_cache[65] = _createElementVNode("span", null, null, -1)),
                  _createElementVNode("span", _hoisted_84, _toDisplayString((_ctx.form.conditions || "").length.toLocaleString("fr-FR")) + "/20 000", 1)
                ])
              ])
            ]),
            _createElementVNode("aside", _hoisted_85, [
              _createElementVNode("section", _hoisted_86, [
                _cache[72] || (_cache[72] = _createElementVNode("span", { class: "st-eyebrow" }, "Aperçu", -1)),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreview,
                          alt: ""
                        }, null, 8, _hoisted_89))
                      : (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.initials), 1))
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.form.name || "Nom de la société"), 1),
                  (_ctx.websiteHref)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.websiteHref,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(_ctx.websiteLabel), 9, _hoisted_91))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_92, [
                  _createElementVNode("li", null, [
                    _cache[67] || (_cache[67] = _createElementVNode("i", {
                      class: "ph ph-envelope-simple",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.form.email || "—"), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[68] || (_cache[68] = _createElementVNode("i", {
                      class: "ph ph-phone",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.form.phone || "—"), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[69] || (_cache[69] = _createElementVNode("i", {
                      class: "ph ph-map-pin",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(_toDisplayString([_ctx.form.adresse, _ctx.form.siege].filter(Boolean).join(", ") || "—"), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[70] || (_cache[70] = _createElementVNode("i", {
                      class: "ph ph-bank",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.bankName || "—"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _cache[71] || (_cache[71] = _createElementVNode("span", null, "Exemple sur un ticket", -1)),
                  _createElementVNode("b", null, "123 " + _toDisplayString(_ctx.form.devis || ""), 1)
                ]),
                _cache[73] || (_cache[73] = _createStaticVNode("<div class=\"st-theme\" aria-hidden=\"true\" data-v-137ee63d><span class=\"st-theme-label\" data-v-137ee63d>Exemple d&#39;interface</span><div class=\"st-theme-nav\" data-v-137ee63d><span class=\"is-active\" data-v-137ee63d><i class=\"ph ph-package\" data-v-137ee63d></i> Colis</span><span data-v-137ee63d><i class=\"ph ph-truck\" data-v-137ee63d></i> Livraisons</span></div><div class=\"st-theme-actions\" data-v-137ee63d><span class=\"btn btn-sm btn-primary\" data-v-137ee63d>Principal</span><span class=\"btn btn-sm btn-secondary\" data-v-137ee63d>Secondaire</span><span class=\"st-theme-badge\" data-v-137ee63d>Nouveau</span></div></div>", 1))
              ])
            ]),
            _createVNode(_Transition, { name: "st-bar" }, {
              default: _withCtx(() => [
                (_ctx.dirtyCount > 0 || _ctx.saving)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _createElementVNode("span", _hoisted_95, [
                        _cache[74] || (_cache[74] = _createElementVNode("i", {
                          class: "ph ph-pencil-simple-line",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.dirtyCount), 1),
                        _createTextVNode(" modification" + _toDisplayString(_ctx.dirtyCount > 1 ? "s" : "") + " non enregistrée" + _toDisplayString(_ctx.dirtyCount > 1 ? "s" : "") + " ", 1),
                        _cache[75] || (_cache[75] = _createElementVNode("kbd", null, "Ctrl", -1)),
                        _cache[76] || (_cache[76] = _createTextVNode("+", -1)),
                        _cache[77] || (_cache[77] = _createElementVNode("kbd", null, "S", -1))
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light",
                          disabled: _ctx.saving,
                          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                        }, "Annuler", 8, _hoisted_97),
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-sm btn-primary",
                          disabled: _ctx.saving
                        }, [
                          (_ctx.saving)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_99))
                            : _createCommentVNode("", true),
                          _cache[78] || (_cache[78] = _createTextVNode(" Enregistrer ", -1))
                        ], 8, _hoisted_98)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 32))
  ]))
}